import React from 'react';
import TerminalLayout from './TerminalLayout';
import { OPT_CONFIG } from '../shared/TerminalConfig';

const OPTLayout = ({ children }) => (
  <TerminalLayout config={OPT_CONFIG}>
    {children}
  </TerminalLayout>
);

export default OPTLayout;